// src/App.tsx
import { BrowserRouter as Router, Navigate, Routes, Route } from "react-router-dom";
import MainLayout from "./components/layouts/MainLayout";
import ProtectedRoute from "./components/security/ProtectedRoute";

import DashboardPage from "./pages/Dashboard/DashboardPage";
import UsersPage from "./pages/Users/UsersPage";
import CompaniesPage from "./pages/Companies/CompaniesPage";
import AuthorizersPage from "./pages/Companies/Authorizers/AuthorizersPage";
import RequestersPage from "./pages/Companies/Requesters/RequestersPage";
import CostCenterPage from "./pages/Companies/CostCenters/CostCenterPage";
import PassesPage from "./pages/Companies/Passes/PassesPage";
import PassengersPage from "./pages/Passengers/PassengersPage";
import ShiftsPage from "./pages/Shifts/ShiftsPage";
import DriversPage from "./pages/Drivers/DriversPage";
import EditDriverPage from "./pages/Drivers/EditDriverPage";
import VehiclesPage from "./pages/Drivers/Vehicles/VehiclesPage";
import LocationsPage from "./pages/Locations/LocationsPage";
import ServicesPage from "./pages/Services/ServicesPage";
import ServiceEditPage from "./pages/Services/ServiceEditPage";
import PaymentStatusPage from "./pages/Services/PaymentStatusPage";
import EmailsPage from "./pages/Emails/EmailsPage";
import EmailEditPage from "./pages/Emails/EmailEditPage";
import ElAbraCatalogPage from "./pages/ElAbra/ElAbraCatalogPage";
import LoginPage from "./pages/Auth/LoginPage"; // asegúrate de tener esta página
import BoletaQrPage from "./pages/Public/BoletaQrPage";
import UsageGuidePage from "./pages/Guide/UsageGuidePage";
import NotificationPreferencesPage from "./pages/NotificationPreferences/NotificationPreferencesPage";
import { canAccessEmailsModule, canAccessNotificationPreferencesModule } from "./hooks/usePermissions";

function App() {
  return (
    <Router>
      <Routes>
        {/* Ruta pública */}
        <Route path="/login" element={<LoginPage />} />
        {/*<Route path="/boleta/qr" element={<BoletaQrPage />} />*/}

        {/* Rutas protegidas */}
        <Route
          path="/"
          element={<ProtectedRoute element={<MainLayout />} />}
        >
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="guide" element={<UsageGuidePage />} />
          <Route path="users" element={<UsersPage />} />
          <Route
            path="notification-preferences"
            element={
              canAccessNotificationPreferencesModule() ? (
                <NotificationPreferencesPage />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            }
          />
          <Route path="companies" element={<CompaniesPage />} />
          <Route path="authorizers" element={<AuthorizersPage />} />
          <Route path="requesters" element={<RequestersPage />} />
          <Route path="cost-center" element={<CostCenterPage />} />
          <Route path="el-abra" element={<ElAbraCatalogPage />} />
          <Route path="passes" element={<PassesPage />} />
          <Route path="passenger" element={<PassengersPage />} />
          <Route path="shifts" element={<ShiftsPage />} />
          <Route path="drivers" element={<DriversPage />} />
          <Route path="drivers/edit/:id" element={<EditDriverPage />} />
          <Route path="vehicles" element={<VehiclesPage />} />
          <Route path="location" element={<LocationsPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route
            path="emails"
            element={canAccessEmailsModule() ? <EmailsPage /> : <Navigate to="/dashboard" replace />}
          />
          <Route
            path="emails/edit/:id"
            element={canAccessEmailsModule() ? <EmailEditPage /> : <Navigate to="/dashboard" replace />}
          />
          <Route path="services/edit/:id" element={<ServiceEditPage />} />
          <Route path="services/payment-status" element={<PaymentStatusPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
